import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../components/layout/Sidebar';
import AutoLogout from '../components/common/AutoLogout';
import Dashboard from './Dashboard';
import GraduationDays from './GraduationDays';
import Departments from './Departments';
import Courses from './Courses';
import CourseLevels from './CourseLevels';
import ExamBodies from './ExamBodies';
import Graduates from './Graduates';
import GownRequests from './GownRequests';
import CountdownManagement from "./CountdownManagement";
import Reports from './Reports';
import Users from './Users';
import AdminBooklets from './AdminBooklets';
import AdminAlumni from './AdminAlumni';
import AdminNominations from "./AdminNominations";
import AdminBlog from './AdminBlog';
import RegisteredAlumni from './RegisteredAlumni';

const AdminDashboard = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <AutoLogout>
      <div className="flex h-screen bg-gray-100">
        <Sidebar isCollapsed={isSidebarCollapsed} toggleSidebar={toggleSidebar} />

        <main className={`flex-1 overflow-y-auto transition-all duration-300`}>
          <div className="p-6 md:p-8">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/graduation-days" element={<GraduationDays />} />
              <Route path="/departments" element={<Departments />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/course-levels" element={<CourseLevels />} />
              <Route path="/exam-bodies" element={<ExamBodies />} />
              <Route path="/graduates" element={<Graduates />} />
              <Route path="/gowns" element={<GownRequests />} />
              <Route path="/countdown" element={<CountdownManagement />} />
              <Route path="/users" element={<Users />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/booklets" element={<AdminBooklets />} />
              <Route path="/alumni" element={<AdminAlumni />} />
	      <Route path="registered-alumni" element={<RegisteredAlumni />} />
              <Route path="nominations" element={<AdminNominations />} />
              <Route path="/blog" element={<AdminBlog />} />
              <Route path="*" element={<Navigate to="/admin" replace />} />
            </Routes>
          </div>
        </main>
      </div>
    </AutoLogout>
  );
};

export default AdminDashboard;
